import { 
  addProduct, getAuditory, saveAdjustInputOutput,
  getAdjustInputOutputPending, deleteRowDetail, updateAdjustInputOutput
 } from "@/api/inputOutputAdjust";
import { getDocumentById } from "@/api/document";
const defaultState = () => {
  return {
    response: {type: null},
    editing: false,
    inventoryAuditId:  null,
    document:{
      type: null,
      id: null,
      userId: null,
      thirdId: null,
      numDays: null,
      date: new Date().toISOString().split('T')[0],
      consecutive: null,
      observation: null,
      branch: null,
      branchDestination: null
    },
    detail: [],
    pending: []
  }
}
export default {
  namespaced: true,
  state: defaultState(),
  mutations:{
    SET_EDITING: (state, connect) => {
      state.editing = connect
    },
    SET_THIRD_ID: (state, connect) => {
      state.document.thirdId = connect
    },
    SET_DATE: (state, connect) => {
      state.document.date = connect
    },
    SET_NUM_DAYS: (state, connect) => {
      state.document.numDays = connect
    },
    SET_DATE: (state, connect) => {
      state.document.date = connect
    },
    SET_OBSERVATION: (state, connect) => {
      state.document.observation = connect
    },
    SET_RESPONSE: (state, connect) => {
      state.response = connect
    },
    SET_AUDITORY_ID: (state, connect) => {
      state.inventoryAuditId = connect
    },
    SET_DOCUMENT_ID: (state, connect) => {
      state.document.id = connect
    },
    SET_PENDING: (state, connect) => {
      state.pending = connect
    },
    SET_DOCUMENT: (state, connect) => {
      state.document = connect
    },
    SET_BRANCH: (state, connect) => {
      state.document[connect.type] = connect.value
    },
    SET_DETAIL: (state, connect) => {
      state.detail = []
      connect.detail.forEach((element) => {
        state.detail.push({
          auditoryId: connect.id,
          detailId: element.id,
          productId: element.product.id,
          code: element.product.codigo,
          description: element.descripcion,
          quantity: element.cantidad,
        });
      });
    },
    RESET_DOCUMENT:(state) => {
      Object.assign(state, defaultState())
    }
  },
  actions:{
    async addProductAction({ commit, state, rootState }, params) {
      try {
        commit('SET_RESPONSE', {type: null},{root: true})
        let productInList = state.detail.find((d) => d.code === params.code);
        if (productInList) {
          params.quantity = parseInt(params.quantity) + parseInt(productInList.quantity);
        }  
        let data = await addProduct(
          params.code,
          params.quantity,
          params.type,
          params.typeDocument,
          rootState.core.logged.sucursal_id,
          rootState.core.logged.id,
          state.inventoryAuditId,
          state.editing,
          state.document.id,
          state.document.thirdId,
          state.document.numDays,
          state.document.observation
        )
        if (data.data["auditory"])
          commit('SET_AUDITORY_ID', data.data["auditory"]["id"])
        if (data.data.auditory) {
          commit('SET_DETAIL', data.data.auditory)
          return;
        }else if(data.data.detail){
          commit('SET_DETAIL', data.data)
          return;
        }
        commit('SET_RESPONSE', {type: 'error', msg: data.data},{root: true})
        
      } catch (error) {
        console.error('Error:' +  error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al agregar el producto'},{root: true})
      }
    },
    async selectAdjustPendingAction({ commit, state }, params) {
      try {
        let data = await getAuditory(params.auditoryId)
        if (data.data.auditory) {
          commit('SET_AUDITORY_ID', params.auditoryId)
          commit('SET_DOCUMENT', {
            type: data.data.auditory.tipo_documento_id,
            id: null,
            thirdId: data.data.auditory.tercero_id,
            numDays: data.data.auditory.dias,
            date: data.data.auditory.fecha,
            observation: data.data.auditory.observacion
          })
          commit('SET_DETAIL', data.data.auditory)
          if (data.data.auditory.third) {
            commit('third/SET_THIRD', { value: data.data.auditory.third, prop: 'all' }, { root: true})
          }
        }
      } catch (error) {
        console.error('Error:' +  error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al seleccionar ajuste pendiente'})
      }
    },
    async editDocumentAction({ commit }, documentId) {
      try {
        commit('SET_EDITING', true)
        commit('SET_AUDITORY_ID', false)
        commit('SET_DOCUMENT_ID', documentId)
        let data = await getDocumentById(documentId)
        commit('third/SET_THIRD', {value: data.data.document.person, prop: 'all'}, { root: true })
        commit('SET_DOCUMENT', {
          type: data.data.document.tipo_id,
          id: data.data.document.id,
          consecutive: data.data.document.consecutivo,
          thirdId: data.data.document.person.id,
          numDays: data.data.document.dias,
          date: data.data.document.fecha,
          observation: data.data.document.observacion,
          branch: data.data.document.branch,
          branchDestination: data.data.document.branch_destination,
        })
        commit('SET_DETAIL', data.data)
      } catch (error) {
        console.error('Error:' +  error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al editar el ajuste'})
      }
    },
    async updateDocumentAction({ commit, state, dispatch }, typeDocument) {
      try {
        if (state.detail.length == 0) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar productos para actualizar el documento.' })
          return false
        }        
        if (!state.document.date) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar una fecha para actualizar el documento.' })
          return false
        }        
        if (state.document.thirdId == null) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar un tercero para actualizar el documento.' })
          return false
        }        
        await updateAdjustInputOutput(
          state.document
        )
        dispatch('resetAction')
        dispatch('getPendingAction', typeDocument)
        commit('SET_RESPONSE', { type: 'success', msg: 'Documento actualizado.' })
      } catch (error) {
        console.error('Error:' +  error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Ocurrió un error' })
      }
    },
    async saveDocumentAction({ commit, state, rootState, dispatch }, params) {
      try {
        if (state.detail.length == 0) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar productos para guardar el documento.' }, {root: true})
          return false
        }
        if (!state.document.date) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar una fecha para guardar el documento.' }, {root: true})
          return false
        }  
        if (state.document.thirdId == null) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar un tercero para guardar el documento.' }, {root: true})
          return false
        }
        await saveAdjustInputOutput(
          state.document,
          state.inventoryAuditId,
          rootState.core.logged.id,
          rootState.core.logged.sucursal_id,
          params.type,
          params.typeDocument,
        )
        dispatch('resetAction')
        dispatch('getPendingAction', params.typeDocument)
        commit('SET_RESPONSE', { type: 'success', msg: 'Documento guardado.' }, {root: true})
      } catch (error) {
        console.error('Error action store:' +  error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Ocurrió un error' }, {root: true})
      }
    },
    async getPendingAction({ commit, state, rootState }, typeDocument){
      try {
        let data = await getAdjustInputOutputPending(rootState.core.logged.branch.id, typeDocument)
        commit('SET_PENDING', data.data.auditory)
      } catch (error) {
        console.log(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al validar ajustes pendientes.'}, {root: true})
      }
    },
    async deleteRowAction({ commit, state, dispatch, rootState }, row){
      try {
        let data = await deleteRowDetail(row.detailId, row.productId , rootState.core.logged.branch.id, state.editing)
        if (state.editing) {
          dispatch('editDocumentAction', state.document.id)
        }else{
          dispatch('selectAdjustPendingAction', row)
        }
        (data.data) ?
        commit('SET_RESPONSE', {type: 'error', msg: data.data})
        : commit('SET_RESPONSE', {type: 'success', msg: 'Registro eliminado.'})
      } catch (error) {
        console.log(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al eliminar registro.'})
      }
    },
    resetAction({ commit }){
      commit('RESET_DOCUMENT')
      commit('third/RESET_THIRD', null, { root: true })
    }
  }
}
